import "../assets/Textarea.css";
import { jsx as t, Fragment as v, jsxs as r } from "preact/jsx-runtime";
import { forwardRef as I } from "preact/compat";
import { c as i } from "./index.2w0W-O47.js";
const b = "_pulseInputGroup_z1ued_1", N = "_pulseInputInvalid_z1ued_8", h = "_pulseInputLabel_z1ued_12", L = "_pulseInput_z1ued_1", x = "_invalid_z1ued_31", z = "_pulseInputTextArea_z1ued_48", g = "_pulseInputOptionalLabel_z1ued_52", q = "_pulseInputErrorMessage_z1ued_53", l = {
  pulseInputGroup: b,
  pulseInputInvalid: N,
  pulseInputLabel: h,
  pulseInput: L,
  invalid: x,
  pulseInputTextArea: z,
  pulseInputOptionalLabel: g,
  pulseInputErrorMessage: q
}, o = ({
  valid: u,
  errorMessage: s
}) => /* @__PURE__ */ t(
  "span",
  {
    className: l.pulseInputErrorMessage,
    "aria-live": "assertive",
    "data-testid": "pulse-input-errorMessage",
    children: !u && s ? s : /* @__PURE__ */ t(v, { children: " " })
  }
), c = ({
  id: u,
  label: s,
  required: e
}) => s ? /* @__PURE__ */ r(
  "label",
  {
    className: l.pulseInputLabel,
    htmlFor: u,
    "data-testid": "pulse-input-label",
    children: [
      s,
      !e && /* @__PURE__ */ t(
        "span",
        {
          className: l.pulseInputOptionalLabel,
          "data-testid": "pulse-input-optionalLabel",
          children: " [optional]"
        }
      )
    ]
  }
) : null, _ = ({
  children: u,
  valid: s
}) => /* @__PURE__ */ t(
  "div",
  {
    className: i(l.pulseInputGroup, {
      [l.pulseInputInvalid]: !s
    }),
    "data-testid": "pulse-input-group",
    children: u
  }
), M = I(
  ({ id: u, label: s, valid: e = !0, errorMessage: a, ...p }, n) => /* @__PURE__ */ r(_, { valid: e, children: [
    /* @__PURE__ */ t(c, { id: u, label: s, required: !!p.required }),
    /* @__PURE__ */ t(
      "input",
      {
        ref: n,
        id: u,
        ...p,
        className: i(
          l.pulseInput,
          {
            [l.pulseInputInvalid]: !e
          },
          p.className
        ),
        "aria-invalid": e ? void 0 : "true",
        "data-testid": "pulse-input"
      }
    ),
    /* @__PURE__ */ t(o, { valid: e, errorMessage: a })
  ] })
), A = I(
  ({ id: u, label: s, valid: e = !0, errorMessage: a, options: p, ...n }, m) => /* @__PURE__ */ r(_, { valid: e, children: [
    /* @__PURE__ */ t(c, { id: u, label: s, required: !!n.required }),
    /* @__PURE__ */ t(
      "select",
      {
        ref: m,
        id: u,
        ...n,
        className: i(
          l.pulseInput,
          {
            [l.pulseInputInvalid]: !e
          },
          n.className
        ),
        "aria-invalid": e ? void 0 : "true",
        "data-testid": "pulse-select",
        children: p.map((d) => /* @__PURE__ */ t("option", { value: d.value, children: d.label }, d.value))
      }
    ),
    /* @__PURE__ */ t(o, { valid: e, errorMessage: a })
  ] })
), O = I(
  ({ id: u, label: s, valid: e = !0, errorMessage: a, ...p }, n) => /* @__PURE__ */ r(_, { valid: e, children: [
    /* @__PURE__ */ t(c, { id: u, label: s, required: !!p.required }),
    /* @__PURE__ */ t(
      "textarea",
      {
        ref: n,
        id: u,
        ...p,
        className: i(
          l.pulseInput,
          l.pulseInputTextArea,
          {
            [l.pulseInputInvalid]: !e
          },
          p.className
        ),
        "aria-invalid": e ? void 0 : "true",
        "data-testid": "pulse-textarea"
      }
    ),
    /* @__PURE__ */ t(o, { valid: e, errorMessage: a })
  ] })
);
export {
  M as I,
  A as S,
  O as T
};
